/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withScope } from '@bingads-webui-react/scope-service';
import { notificationApi } from '@bingads-webui-react/notification-center';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';
import {
  withSiteMap,
  siteMapPropType,
  processor,
  findSiteMap,
} from '@bingads-webui-react/with-site-map';
import { withHotKeys } from './hot-keys';
import { getNavigateShortcutKeys } from './util';
import { ShortcutType } from './shortcut-list';

class HotKeyNavigatorRaw extends React.Component {
  constructor(props) {
    super(props);
    this.navigatorList = getNavigateShortcutKeys(props.siteMap);
  }

  shouldComponentUpdate(nextProps) {
    if (this.navigatorList.indexOf(nextProps.hotKey) > -1 && nextProps.count !== this.props.count) {
      return true;
    }
    return false;
  }

  render() {
    const {
      hotKey,
      scope,
      i18n,
      siteMap,
    } = this.props;
    const navigatedSiteMapItem = findSiteMap(siteMap, item => item.shortcut === hotKey);
    let navigatedURL = '';
    if (navigatedSiteMapItem && !!hotKey) {
      navigatedURL = navigatedSiteMapItem.routePrefix + navigatedSiteMapItem.route;
      scope.save(navigatedURL);
      const hotKeyDisplay = hotKey.replace('+', ' ').toUpperCase();
      const notificationText = `${hotKeyDisplay}: ${i18n.getString(_TL_('Go to'))} ${i18n.getString(navigatedSiteMapItem.name)}`;
      notificationApi.showInfo(notificationText);
    }
    return (null);
  }
}

HotKeyNavigatorRaw.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  hotKey: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  siteMap: siteMapPropType.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  scope: PropTypes.object.isRequired,
};

export const HotKeyNavigator =
  withSiteMap(
    withScope(withInstrumentation(withHotKeys(withI18nConsumer(HotKeyNavigatorRaw), ShortcutType.Navigation))),
    [processor.processPermissions, processor.processPath, processor.processScope]
  );
